import React from 'react';
import { getSdgAlt, getSdgImage } from '../../constants/sdgImages';
import { getSdgDisplayName } from '../../constants/sdgs';

interface SdgGoalImageProps {
  sdg: number;
}

/** SDG tile that shows the official goal name when the user hovers that goal. */
const SdgGoalImage: React.FC<SdgGoalImageProps> = ({ sdg }) => {
  const src = getSdgImage(sdg);
  const name = getSdgDisplayName(sdg);
  if (!src) return null;

  const label = name ?? `SDG Goal ${sdg}`;

  return (
    <div className="group/sdg relative w-full min-w-0">
      <img src={src} alt={getSdgAlt(sdg)} loading="lazy" className="h-auto w-full rounded-lg" />
      <div
        role="tooltip"
        className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center overflow-hidden rounded-lg bg-black px-1 py-1 opacity-0 transition-opacity duration-150 group-hover/sdg:opacity-100"
      >
        <p className="w-full break-words text-center text-[10px] font-medium leading-tight text-white sm:text-[11px]">
          {label}
        </p>
      </div>
    </div>
  );
};

export default SdgGoalImage;
